var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webdatalist" },
    [
      _c(
        "f7-list",
        { attrs: { "media-list": "", id: "draft-list" } },
        _vm._l(_vm.filteredDrafts, function (draft) {
          return _c(
            "li",
            {
              staticClass: "swipeout",
              on: {
                "swipeout:deleted": function ($event) {
                  return _vm.deleteDraft(draft.idDraft)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "swipeout-content item-content draftTaphold boxRequest",
                  attrs: {
                    "data-item": draft.idDraft,
                    "data-complete": draft.isComplete,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createPayments(draft)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "item-media" }, [
                    _c("i", { staticClass: "icon list-icon icon-edit" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-inner" }, [
                    _c("div", { staticClass: "item-title-row" }, [
                      _c("table", { attrs: { width: "100%" } }, [
                        _c("tr", [
                          _c("td", { staticClass: "requestTitle" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(draft.draftName) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { width: "60%" } }, [
                            _c("div", { staticClass: "showLargeScreenOnly" }, [
                              draft.isComplete === "1"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "item-subtitle streammindBlueFont",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getStatusLabel(draft.isComplete)
                                        )
                                      ),
                                    ]
                                  )
                                : draft.isComplete === "0"
                                ? _c(
                                    "div",
                                    { staticClass: "item-subtitle redFont" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getStatusLabel(draft.isComplete)
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    draft.isComplete === "1"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "item-subtitle streammindBlueFont showSmallScreenOnly",
                          },
                          [_vm._v(_vm._s(_vm.getStatusLabel(draft.isComplete)))]
                        )
                      : draft.isComplete === "0"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "item-subtitle redFont showSmallScreenOnly",
                          },
                          [_vm._v(_vm._s(_vm.getStatusLabel(draft.isComplete)))]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "swipeout-actions-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "swipeout-delete",
                    attrs: {
                      href: "#",
                      "data-confirm":
                        "You won't be able to recover this draft from MoneyRoad",
                      "data-confirm-title": "Remove?",
                      "data-close-on-cancel": "true",
                    },
                  },
                  [_vm._v("\n          Delete\n        ")]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }